<template>
  <div class="item-loca">
    <div class="item-loca-wg item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.wg.title }}</span>
        <img class="cosDiv" src="../../assets/c.png" :alt="showData.wg.title" />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.wg.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.wg.title"
        />
        <img class="hidden-img" :src="showData.wg.url" alt="外购电力" />
        <span style="display: block">{{ showData.wg.head }}</span>
        <div class="power">
          <span> {{ showData.wg.desc }}</span>
          <span> {{ showData.wg.data }}</span>
        </div>
      </div>
    </div>
    <div class="item-loca-1pf item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.firstPf.title }}</span>
        <img
          class="cosDiv"
          src="../../assets/c.png"
          :alt="showData.firstPf.title"
        />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.firstPf.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.firstPf.title"
        />
        <img class="hidden-img" :src="showData.firstPf.url" alt="" />
        <!-- <video id="myVideo1" class="video-js vjs-big-play-centered">
          <source :src="showData.firstPf.url" type="video/mp4" />
        </video> -->
        <span style="display: block">{{ showData.firstPf.head }}</span>
        <div class="power">
          <span> {{ showData.firstPf.desc }}</span>
          <span> {{ middata.firstOut }}tCO₂</span>
        </div>
      </div>
    </div>
    <div class="item-loca-yr item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.yr.title }}</span>
        <img class="cosDiv" src="../../assets/c.png" :alt="showData.yr.title" />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.yr.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.yr.title"
        />
        <!-- <video id="myVideo2" class="video-js vjs-big-play-centered">
          <source :src="showData.yr.url" type="video/mp4" />
        </video> -->
        <img class="hidden-img" :src="showData.yr.url" alt="" />
        <span style="display: block">{{ showData.yr.head }}</span>
        <div class="power">
          <span> {{ showData.yr.flineDesc }}</span>
          <span> {{ objNews.ffadianN }}MW</span>
        </div>
        <div class="power">
          <span> {{ showData.yr.slineDesc }}</span>
          <span> {{ objNews.sfadiann }}MW</span>
        </div>
        <div class="power">
          <span> {{ showData.yr.yrdesc }}</span>
          <span> {{ objNews.yurefadian }}MWh</span>
        </div>
      </div>
    </div>
    <div class="item-loca-qrl item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.qrl.title }}</span>
        <img
          class="cosDiv"
          src="../../assets/c.png"
          :alt="showData.qrl.title"
        />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.qrl.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.qrl.title"
        />
        <!-- <video id="myVideo3" class="video-js vjs-big-play-centered">
          <source :src="showData.qrl.url" type="video/mp4" />
        </video> -->
        <img class="hidden-img" :src="showData.qrl.url" alt="" />
        <span style="display: block">{{ showData.qrl.head }}</span>
        <div class="power">
          <span> {{ showData.qrl.desc }}</span>
          <span> {{ objNews.jieshengbiaomei }}t</span>
        </div>
      </div>
    </div>
    <div class="item-loca-2pf item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.secondPf.title }}</span>
        <img
          class="cosDiv"
          src="../../assets/c.png"
          :alt="showData.secondPf.title"
        />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.secondPf.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.secondPf.title"
        />
        <!-- <video id="myVideo4" class="video-js vjs-big-play-centered">
          <source :src="showData.secondPf.url" type="video/mp4" />
        </video> -->
        <img class="hidden-img" :src="showData.secondPf.url" alt="" />
        <span style="display: block">{{ showData.secondPf.head }}</span>
        <div class="power">
          <span> {{ showData.secondPf.desc }}</span>
          <span> {{ middata.secondOut }}tCO₂</span>
        </div>
      </div>
    </div>
    <div class="item-loca-gf item-loca-nomal" @click="clickDetail($event)">
      <div class="itemWg">
        <span class="nomalFont">{{ showData.gf.title }}</span>
        <img class="cosDiv" src="../../assets/c.png" :alt="showData.gf.title" />
      </div>
      <img
        class="dianImg"
        src="../../assets/dian.png"
        :alt="showData.gf.title"
      />
      <div class="hidden">
        <img
          class="hidden-jiao"
          src="../../assets/jiao.png"
          :alt="showData.gf.title"
        />
        <!-- <video id="myVideo5" class="video-js vjs-big-play-centered">
          <source :src="showData.gf.url" type="video/mp4" />
        </video> -->
        <img class="hidden-img" :src="showData.gf.url" alt="" />
        <span style="display: block">{{ showData.gf.head }}</span>
        <div class="power">
          <span> {{ showData.gf.desc }}</span>
          <span> {{ objNews.guangfufadian }}MW</span>
        </div>
      </div>
    </div>
    <!-- <img class="dianImg" src="../../assets/dian.png" alt="" /> -->
    <!-- 底部切换  @click="checkJinan(jinanData)" -->
    <div class="bottomChange">
      <div class="itemChange d-flex">
        <img src="../../assets/zibo.png" alt="徐州万华水泥厂1" />
        <div class="textChange">
          <span class="spSpan">区域1</span>
          <div class="spDiv">
            <span>月度用电量：{{ 1490 }}kW·h</span>
            <span>昨日用电量：{{ 53 }}kW·h</span>
            <span>当天用电量：{{ 60 }}kW·h</span>
          </div>
        </div>
      </div>
      <div class="itemChange d-flex">
        <img src="../../assets/jinan.jpg" alt="济南万华水泥厂" />
        <div class="textChange">
          <span class="spSpan">区域2</span>
          <div class="spDiv">
            <span>月度用电量：{{ 2000 }}kW·h</span>
            <span>昨日用电量：{{ 64 }}kW·h</span>
            <span>当天用电量：{{ 70 }}kW·h</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomChange2">
      <img src="../../assets/logo24.png" />
    </div>
  </div>
</template>

<script>
import { number } from 'echarts'

export default {
  name: "topmain",
  props: {
    middata: {
      type: Object,
      default: null
    },
    ziboDataTrue: {
      type: Object,
      default: null
    },
    jinanDatasTrue: {
      type: Object,
      default: null
    },
    outBuyPower: {
      type: Number,
      default: null
    },
    objNews: {
      type: Object,
      default: null
    }

  },
  data () {
    return {
      zbxiane: {
        monthsOut: '5万tCO₂',
        carbonIntensity: '0.2tCO₂',
        powerLimit: '28KW·h'
      },
      jnxiane: {
        monthsOut: '5万tCO₂',
        carbonIntensity: '0.2tCO₂',
        powerLimit: '28KW·h'
      },
      player: [],
      showData: {},
      ziboData: {
        wg: {
          title: '外购电力',
          head: '外购电力',
          url: require('../../assets/waigou.jpeg'),
          desc: '购电量',
          data: '120KW·h'
        },
        bj: {
          title: 'CCUS年捕集量',
          head: 'CCUS年捕集量',
          url: require('../../assets/1.mp4'),
          desc: '捕集量',
          data: '332tCO₂'
        },
        firstPf: {
          title: '1号线排放',
          head: '1号线排放',
          url: require('../../assets/oneroad.jpeg'),
          desc: '排放量',
          data: '332tCO₂'
        },
        yr: {
          title: '余热发电',
          head: '余热发电',
          url: require('../../assets/yure.jpeg'),
          flineDesc: '1号线发电功率',
          flineData: '22MW',
          slineDesc: '2号线发电功率',
          slineData: '55MW',
          yrdesc: '余热发电量',
          yrData: '22KW·h',
        },
        qrl: {
          title: '氢燃料燃烧',
          head: '氢燃料燃烧',
          url: require('../../assets/qinngranliao.jpeg'),
          desc: '节省标煤量',
          data: '1125t'
        },
        secondPf: {
          title: '2号线排放',
          head: '2号线排放',
          url: require('../../assets/secondroad.jpeg'),
          desc: '排放量',
          data: '73tCO₂'
        },
        gf: {
          title: '光伏发电',
          head: '光伏发电',
          url: require('../../assets/guangfu.jpeg'),
          desc: '发电功率',
          data: '15MW'
        }
      },

    }
  },
  watch: {
    outBuyPower (newValue) {
      if (newValue !== null) {
        this.showData.wg.data = newValue + 'kW·h'
      }
    },
    middata (newValue) {
      if (newValue !== null) {
        this.showData.firstPf.data = newValue + 'tCO₂'
        this.showData.secondPf.data = newValue + 'tCO₂'
      }
    },
    ziboDataTrue (newValue) {
      if (newValue !== null) {
        this.ziboDataTrue = newValue
      }
    },
    jinanDatasTrue (newValue) {
      if (newValue !== null) {
        this.jinanDatasTrue = newValue
      }
    },
    objNews (newValue) {
      console.log(newValue)
      if (newValue !== null) {
        this.objNews = newValue
      }
    },
  },
  created () {
    this.showData = this.ziboData
    this.showData.firstPf.data = this.middata.firstOut + 'tCO₂'
    this.showData.secondPf.data = this.middata.secondOut + 'tCO₂'
  },

  methods: {
    // 初始化视频 video.js
    initVideo () {
      //初始化视频方法
      for (let i = 1; i < 6; i++) {
        this.player[i] = this.$video('myVideo' + i, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: 'muted',
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "300px",
          //设置视频播放器的显示高度（以像素为单位）
          height: "180px",
          bigPlayButton: true,
          loop: true
        });
      }
    },
    clickDetail (e) {
      //return //东华点击需关闭
      var theNode = e.currentTarget
      let showItem = theNode.lastElementChild
      let indexClass = showItem.classList.value.indexOf('showModel')
      // this.player.play()
      if (indexClass === -1) {
        showItem.classList.add("showModel")
      } else {
        showItem.classList.remove("showModel")
      }
    },
    checkZibo (e) {
      this.showData = e
      let allDom = document.getElementsByClassName('item-loca-nomal')
      for (let i = 0; i < allDom.length; i++) {
        let cacelSow = allDom[i].lastElementChild.classList.value.indexOf("showModel")
        if (cacelSow = -1) {
          allDom[i].lastElementChild.classList.remove("showModel")
        }
      }
    },
    checkJinan (e) {
      this.showData = e
      let allDom = document.getElementsByClassName('item-loca-nomal')
      for (let i = 0; i < allDom.length; i++) {
        let cacelSow = allDom[i].lastElementChild.classList.value.indexOf("showModel")
        if (cacelSow = -1) {
          allDom[i].lastElementChild.classList.remove("showModel")
        }
      }
    }
  },
  mounted () {
    // this.initVideo();
  }
}
</script>

<style scoped>
.item-loca {
  height: 100%;
  position: relative;
}
.dianImg {
  max-width: 76px;
}
.itemWg {
  border: 2px solid #69d4e1;
  background-color: rgba(3, 3, 3, 0.62);
  padding: 7px 15px;
  position: relative;
  margin-left: 36px;
  margin-bottom: 8px;
  color: #fff;
}
.itemWg:hover {
  cursor: pointer;
}
.itemWg span {
  font-size: 20px;
}
.item-loca-nomal {
  position: absolute;
}
.cosDiv {
  position: absolute;
  left: -2px;
  bottom: -17px;
}
.item-loca-yr {
  left: 15.4vw;
  top: 20.5vh;
  z-index: 9;
}
.item-loca-wg {
  left: 7.5vw;
  top: 1.5vh;
}
.item-loca-bj {
  left: 19vw;
  top: 7.5vh;
}
.item-loca-2pf {
  left: 33.5vw;
  top: 32.5vh;
}
.item-loca-qrl {
  left: 22vw;
  top: 36.5vh;
}
.item-loca-1pf {
  left: 25vw;
  top: 16.5vh;
}

.item-loca-gf {
  right: 2.1vw;
  top: 34.5vh;
}
.hidden {
  position: absolute;
  border: 2px solid #69d4e1;
  background-color: rgba(3, 3, 3, 0.67);
  padding: 10px 15px;
  line-height: 1.8;
  min-width: 240px;
  right: 100%;
  display: none;
}
.showModel {
  display: block;
  z-index: 9;
}
.hidden span {
  font-size: 18px;
  font-weight: bold;
  font-family: "黑体";
  color: #fff;
}
.hidden .power {
  display: flex;
}
.hidden .power span {
  font-weight: normal;
  font-size: 16px;
}
.hidden .power span:first-child {
  padding-right: 45px;
}
.hidden-jiao {
  max-width: 40px;
  position: absolute;
  right: -30px;
  top: -30px;
}
.hidden-img {
  max-width: 180px;
}
.bottomChange2 {
  position: absolute;
  bottom: 16vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.bottomChange {
  position: absolute;
  bottom: 30vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.textChange {
  margin-left: 15px;
}
.bottomChange span {
  min-width: 168px;
  display: block;
  color: #fff;
  font-size: 14px;
  font-family: "黑体";
  padding: 3px 10px;
}
.spDiv {
  background: rgba(26, 60, 96, 0.5);
  padding: 3px 0px;
}
.bottomChange span.spSpan {
  font-size: 18px;
  margin-bottom: 7px;
  background: rgba(26, 60, 96, 0.5);
}
.itemChange {
  background: rgba(3, 27, 51, 0.76);
  padding: 15px 17px;
  margin: 0px 8px;
  border: 1px solid #578aef;
}
</style>



// WEBPACK FOOTER //
// src/components/mid/topmain.vue